import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-show-schedule',
  templateUrl: './show-schedule.component.html',
  styleUrls: ['./show-schedule.component.scss']
})
export class ShowScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
